import { FC } from "react";
import {
  Control,
  UseFormRegister,
  UseFormSetValue,
  UseFormSetError,
  UseFormClearErrors,
} from "react-hook-form";
import InputField from "app/components/common/inputs/InputField";
import FormGroup from "app/components/common/inputs/FormGroup";
import ErrorsMessage from "app/components/common/errors/ErrorsMessage";
import AutocompleteLocations from "app/components/common/AutocompleteLocations";
import SelectField from "app/components/common/inputs/SelectField";
import DependentAgesFields from "app/components/common/inputs/DependentAgesFields";
import {
  maritalstatusOptions,
  visastatusOptions,
  stateOfIssueOptions,
  numberDependentsOptions,
} from "app/utils/staticValues";

interface Props {
  control: Control<any>;
  errors: any;
  register: UseFormRegister<any>;
  setValue: UseFormSetValue<any>;
  setError: UseFormSetError<any>;
  clearErrors: UseFormClearErrors<any>;
  visaStatus: string;
  maritalStatus: string;
  visaStatusValue: string;
  visaNumber: string;
  addressStateName: string;
  addressStreetName: string;
  addressPostCodeName: string;
  numberOfDependents: number;
  numberOfDependentsName: string;
  dependentAges: string;
  disabledOnisSpouse?: boolean;
}

const DynamicFormFour: FC<Props> = ({
  control,
  errors,
  register,
  setValue,
  setError,
  clearErrors,

  visaStatus,
  maritalStatus,
  visaStatusValue,
  visaNumber,
  addressStateName,
  addressStreetName,
  addressPostCodeName,
  numberOfDependents,
  numberOfDependentsName,
  dependentAges,
  disabledOnisSpouse = false,
}) => {
  const getErrorMessage = (fieldName: string) => {
    const fieldNames = fieldName.split(".");
    return fieldNames.reduce((acc, key) => acc && acc[key], errors);
  };

  return (
    <>
      <FormGroup>
        <SelectField
          label="Visa Status"
          name={visaStatus}
          control={control}
          options={visastatusOptions}
          placeholder="Please select visa status"
          error={getErrorMessage(visaStatus)?.message as string}
          required={true}
          className="flex-1"
        />
        <SelectField
          label="Marital Status"
          name={maritalStatus}
          control={control}
          options={maritalstatusOptions}
          placeholder="Please select marital status"
          error={getErrorMessage(maritalStatus)?.message as string}
          required={true}
          className="flex-1"
          isDisabled={disabledOnisSpouse}
        />
      </FormGroup>

      {visaStatusValue === "Other" && (
        <FormGroup>
          <InputField
            label="Visa number"
            name={visaNumber}
            control={control}
            type="text"
            required={visaStatusValue === "Other"}
            placeholder="Enter your visa number (e.g., 45463)"
            error={getErrorMessage(visaNumber)?.message as string}
            className="flex-1"
          />
        </FormGroup>
      )}

      <FormGroup className="!mb-0">
        <AutocompleteLocations
          label="Current address"
          FieldName={addressStreetName}
          placeholder="2464 Royal Ln. Mesa, New Jersey 45463"
          register={register}
          setValue={setValue}
          setError={setError}
          required={true}
          className="flex-1"
          error={getErrorMessage(addressStreetName)?.message as string}
          stateFieldName={addressStateName}
          postCodeFieldName={addressPostCodeName}
          clearErrors={clearErrors}
          disabled={disabledOnisSpouse}
        />
        <div className="flex-1">
          <FormGroup direction="row">
            <SelectField
              label="State"
              name={addressStateName}
              control={control}
              options={stateOfIssueOptions}
              placeholder="Select State"
              error={getErrorMessage(addressStateName)?.message as string}
              required={true}
              className="flex-1"
              isDisabled={disabledOnisSpouse}
            />
            <InputField
              label="Post Code"
              name={addressPostCodeName}
              control={control}
              type="text"
              required={true}
              placeholder="45463"
              error={getErrorMessage(addressPostCodeName)?.message as string}
              className="flex-1"
              disabled={disabledOnisSpouse}
            />
          </FormGroup>
        </div>
      </FormGroup>
      <FormGroup>
        <SelectField
          label="Number of Dependents (Under 18)"
          name={numberOfDependentsName}
          control={control}
          options={numberDependentsOptions}
          placeholder="4"
          error={getErrorMessage(numberOfDependentsName)?.message as string}
          required={true}
          className="flex-1"
          isDisabled={disabledOnisSpouse}
        />
        <div className="flex-1">
          <DependentAgesFields
            numberOfDependents={numberOfDependents}
            control={control}
            errors={errors}
            fieldName={dependentAges}
            disabled={disabledOnisSpouse}
          />
        </div>
      </FormGroup>
    </>
  );
};

export default DynamicFormFour;
